import { render } from "./TerminalItem.vue?vue&type=template&id=0c2f25f6"
import script from "./TerminalItem.vue?vue&type=script&lang=js"
export * from "./TerminalItem.vue?vue&type=script&lang=js"

import "./TerminalItem.vue?vue&type=style&index=0&id=0c2f25f6&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__